import * as React from 'react';
import { PrimaryButton, DefaultButton } from '@fluentui/react/lib/Button';
import { getQueuedEmails } from '../actions/queueWorker';

export interface AppProps {
    hide: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

class QueueConfirmation extends React.Component<AppProps> {
    
    public render() {
        if (this.props.hide) {
            return null;
        }

        const queuedEmails = getQueuedEmails();
        const selected_clients = JSON.parse(sessionStorage.getItem('selected_clients')) || [];
        const file_to_type = JSON.parse(sessionStorage.getItem('file_to_type')) || { id: 'note', name: 'Note' };
        const clientNames = selected_clients.map(c => c.name).join(', ');
        const fileTypeText = file_to_type.id === 'note' ? 'note' : file_to_type.id === 'existingnote' ? 'existing note' : 'task';

        return (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 10000
            }}>
                <div style={{
                    backgroundColor: '#ffffff',
                    padding: '24px',
                    borderRadius: '8px',
                    maxWidth: '500px',
                    width: '90%',
                    boxShadow: '0 4px 16px rgba(0,0,0,0.2)'
                }}>
                    <h3 style={{
                        margin: '0 0 16px 0',
                        fontSize: '16px',
                        fontWeight: 600,
                        color: '#323130'
                    }}>
                        You are about to file multiple emails
                    </h3>
                    <p style={{
                        margin: '0 0 24px 0',
                        fontSize: '13px',
                        color: '#605e5c',
                        lineHeight: '1.5'
                    }}>
                        Are you sure you want to file <strong>{queuedEmails.length} email{queuedEmails.length > 1 ? 's' : ''}</strong> to one {fileTypeText}{clientNames ? ` for ${clientNames}` : ''}?
                    </p>
                    <div style={{
                        display: 'flex',
                        gap: '12px',
                        justifyContent: 'flex-end'
                    }}>
                        <DefaultButton
                            data-automation-id='btnCancelQueue'
                            text='Cancel'
                            onClick={this.props.onCancel}
                            styles={{
                                root: {
                                    minWidth: '80px',
                                    minHeight: '36px',
                                    fontSize: '13px',
                                    borderRadius: '6px',
                                    border: '2px solid #5D3FD6',
                                    color: '#5D3FD6',
                                    fontWeight: 500,
                                    backgroundColor: '#ffffff'
                                },
                                rootHovered: {
                                    backgroundColor: '#f8f7fc',
                                    borderColor: '#5D3FD6'
                                }
                            }}
                        />
                        <PrimaryButton
                            data-automation-id='btnConfirmQueue'
                            text='File'
                            onClick={this.props.onConfirm}
                            styles={{
                                root: {
                                    minWidth: '80px',
                                    minHeight: '36px',
                                    fontSize: '13px',
                                    borderRadius: '6px',
                                    backgroundColor: '#5D3FD6',
                                    border: 'none',
                                    fontWeight: 500
                                },
                                rootHovered: {
                                    backgroundColor: '#4a2fb5'
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default QueueConfirmation;
